import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { Configuration } from "Configuration";
import {
    UserGridConfigClient,
    UserMappingConfigResult,
    BaseResult,
    UserMappingConfigContextParameter,
    UserGridConfigRequest,
} from "./Client";

/**
 * Service for requesting gridDefinitions.
 * @hidden
 */
export class UserGridConfigService extends BaseService {
    /**
     * Sets UserGridConfiguration
     * @param gridId
     * @param configuration
     */
    public setConfig(
        mappingName: string,
        isSystem: boolean,
        userMappingConfigId: number,
        name: string,
        userGridConfig: UserGridConfigRequest[]
    ): Promise<UserMappingConfigResult> {
        let param: UserMappingConfigContextParameter = {
            MappingName: mappingName,
            IsSystem: isSystem,
            UserMappingConfigID: userMappingConfigId,
            Name: name,
            UserGridConfig: userGridConfig,
        };

        let params = $.extend(param, CommandService.getRequestParameters());
        let client = new UserGridConfigClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<UserMappingConfigResult>((resolve, reject) => {
            client.setUserMappingConfig(
                params,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    /**
     * Sets UserGridConfiguration
     * @param gridId
     * @param configuration
     */
    public deleteConfig(mappingName: string, userMappingConfigId: number): Promise<BaseResult> {
        let param: UserMappingConfigContextParameter = {
            UserMappingConfigID: userMappingConfigId,
            MappingName: mappingName,
        };
        let params = $.extend(param, CommandService.getRequestParameters());
        let client = new UserGridConfigClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<BaseResult>((resolve, reject) => {
            client.deleteUserMappingConfig(
                params,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    /**
     * Sets UserGridConfiguration
     * @param gridId
     * @param configuration
     */
    public setInitial(mappingName: string, userMappingConfigId: number): Promise<BaseResult> {
        let param: UserMappingConfigContextParameter = {
            UserMappingConfigID: userMappingConfigId,
            MappingName: mappingName,
        };
        let params = $.extend(param, CommandService.getRequestParameters());
        let client = new UserGridConfigClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<BaseResult>((resolve, reject) => {
            client.setInitialUserMappingConfig(
                params,
                (res) => resolve(res),
                (exception, reason) => reject(exception)
            );
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }
}
